import { render, staticRenderFns } from "./KcHeader.vue?vue&type=template&id=133e347e&scoped=true"
import script from "./KcHeader.vue?vue&type=script&lang=js"
export * from "./KcHeader.vue?vue&type=script&lang=js"
import style0 from "./KcHeader.vue?vue&type=style&index=0&id=133e347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e347e",
  null
  
)

export default component.exports